import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useDeleteVault(id) {
  const queryClient = useQueryClient()
  const action = async () => {
    const response = await httpClient.delete(`team/vault/${id}`)
    return response.data
  }

  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      toast.success('Vault deleted successfully')
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
    },
    onError: (error) => {
      console.error('Error deleting vault:', error)
      toast.error(
        error?.response?.data?.message ?? 'Could not delete the vault.',
      )
    },
  })
}
